import { Loader } from 'lucide-react';
import { useOidcActivation } from '@/modules/auth/hooks/use-oidc-activation';

export const OidcCallbackPage = () => {
  useOidcActivation();

  return (
    <div className="fixed inset-0 z-10 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center space-y-4">
        <Loader className="h-8 w-8 animate-spin" />
        <p className="text-sm text-medium-emphasis">Signing in...</p>
      </div>
    </div>
  );
};
